<div class="popup-container">
    <header class="header">
        <svg style="cursor:pointer" (click)="closePopup()" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5 6.5L6.5 19.5" stroke="#CECECE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.5 6.5L19.5 19.5" stroke="#CECECE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
            
    </header>
    <content class="content">
        <div class="contentwrapper">
            <svg width="126" height="94" viewBox="0 0 126 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.3485 57.2427C18.7606 62.1014 16.6056 65.8404 13.1969 70.2883L9.49948 69.6329C13.7859 64.7925 16.2932 62.9454 14.7976 58.5325L19.3469 57.2438L19.3485 57.2427Z" fill="#06DAF6"/>
                <path d="M113.585 53.4713C108.89 53.9667 105.237 52.9292 100.875 50.9924L101.426 47.7811C106.185 50.3699 108.023 52.0825 112.242 49.9445L113.585 53.4713Z" fill="#007BFF"/>
                <path d="M81.5117 87.0781L79 89.5898L81.5117 92.1016L84.0235 89.5898L81.5117 87.0781Z" fill="#FFB900"/>
                <path d="M23.5117 7.0781L21 9.58984L23.5117 12.1016L26.0235 9.58984L23.5117 7.0781Z" fill="#E23AFF"/>
                <circle cx="61.5" cy="50.5781" r="36.5" fill="#E1FFD5"/>
                <circle cx="61" cy="51.0781" r="23" fill="#0BA842"/>
                <path d="M71.9526 42.8633L56.8931 57.9228L50.0479 51.0776" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M75.0761 10.786C76.9435 7.94677 77.41 5.19887 77.483 1.6493L75.0761 0.781116C75.3265 4.83498 75.9188 6.67058 73.0652 8.57688L75.0756 10.7849L75.0761 10.786Z" fill="#FF5C33"/>
                <path d="M92.5752 28.4463C92.2567 26.4995 92.828 22.7817 95.4341 22.1748C98.3121 21.5046 99.8676 22.2822 101.233 20.8947C103.633 18.4568 101.884 16.1254 103.918 13.0786" stroke="#E862FF" stroke-width="2" stroke-linecap="round"/>
                <path d="M22.8118 37.7046C19.7759 33.2197 16.8844 38.8044 13.2829 34.1847C11.1247 31.4162 7.7492 34.9349 5.85974 33.636C2.53981 31.3537 4.93423 27.9431 1.00029 26.2169" stroke="#15F363" stroke-width="2" stroke-linecap="round"/>
                <circle cx="124" cy="34.0781" r="2" fill="#FF852F"/>
                <circle cx="29" cy="90.0781" r="3" fill="#1C60FF"/>
                <circle cx="43.5" cy="9.57812" r="1.5" fill="#02E7F7"/>
                </svg>
                
                
            <p class="text-type-eleven message">{{message()}}</p>
            <span class="text-type-eleven submessage tiny-txt">{{submessage()}}</span>
        </div>
        <div class="btnWrapper">
            <button app-btn class="closeBtn" (click)="closePopup()">Ok</button>
        </div>

            
    </content>
</div>